import { type FC } from 'preact/compat';

import { type Game } from '@/shared/api/game/types';

import { AbLoadingScreen } from '@/widget/ab-loading-screen/ui';

import { LoadingMode } from '../../hooks/use-loading-mode';
import { DefaultLoadingScreen } from './DefaultLoadingScreen';
import { HideUILoadingScreen } from './HideUILoadingScreen';

interface Props {
  mode: LoadingMode;
  game: Game | null;
  pdOpen: boolean;
  isDev: boolean;
}

export const LoadingScreen: FC<Props> = ({ mode, game, pdOpen, isDev }) => {
  switch (mode) {
    case LoadingMode.AbTest:
      return <AbLoadingScreen pdOpen={pdOpen} showIntro />;
    case LoadingMode.AbTestV2:
      return <AbLoadingScreen pdOpen={pdOpen} />;
    case LoadingMode.HideUI:
      return <HideUILoadingScreen pdOpen={pdOpen} />;
    case LoadingMode.Default:
      return <DefaultLoadingScreen game={game} pdOpen={pdOpen} isDev={isDev} />;
  }
};
